import React from 'react';

import cn from 'classnames';

import css from './title.css';

interface Props {
    tag?: 'div' | 'h1';
    className?: string;
}

const Title: React.FC<React.PropsWithChildren<Props>> = ({
    tag,
    className,
    children,
}) => {
    const intrinsicTag = tag || null;

    return (
        <div className={cn(css.root, className)}>
            {React.createElement(
                intrinsicTag || 'div',
                intrinsicTag ? { className: css.text } : {},
                children,
            )}
        </div>
    );
};

export default Title;
